import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Serie } from '../../../models/serie';
import { ParametroService } from '../../../services/parametro.service';
import { SerieService } from '../../../services/serie.service';

@Component({
  selector: 'app-serie-egreso-modal',
  templateUrl: './serie-egreso-modal.component.html',
  styleUrls: ['./serie-egreso-modal.component.css'],
  providers: [ParametroService, SerieService],
})
export class SerieEgresoModalComponent implements OnInit {
  @Input() series: Array<Serie>;
  @Input() bodega_id: string;
  @Input() producto_id: string; 
  @Output() sendSeries = new EventEmitter<any>();
  public series_all: Array<Serie>;
  public serie_barcode: Serie;
  public nombre_codigo: string = "";
  // public series: Array<Serie>;
  public codigo: string;
  // public serie: any;
  public loading: boolean;
  public not_found_code: string;
  public selectAll: boolean;
  @ViewChild('inputBarcode') searchElement: ElementRef;
  constructor(
    public bsModalRef: BsModalRef,
    private parametroService: ParametroService,
    private serieService: SerieService,
  ) {
    this.series_all = [];
    this.serie_barcode = null;
    this.codigo = "";
    this.loading = false;
    this.not_found_code = "";
    this.selectAll = false;
   }

   ngOnInit() {
    this.loading = true;
    this.getNombeCodigo().then(
      res => this.loading = false,
      err => this.loading = false,
    );
    this.getAllByInventario();
    
  }

  setSelected(){
    
    this.series.forEach(s => {
    
      let serie = this.series_all.filter(x => x.codigo.toString().trim() == s.codigo.toString().trim())[0];
    
      if(serie) serie.is_selected = true;
    });

    this.series_all.forEach(serie=>{
      if(serie.is_selected){
        this.selectAll = true;
      }else{
        this.selectAll = false;
      }
    });
  }

  getNombeCodigo(){
    return new Promise ((resolve, reject) => {
      this.parametroService.getById(31).subscribe(
        res => {
          this.nombre_codigo = res.valor;
          resolve(true);
        },
        err => {
          reject();
        }
      )
    });
  }
  
  ngAfterViewInit(){
    this.setFocus();
  }

  setFocus(){
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    }, 500);
  }

  onSearchBarcode(event){
    let keycode = event.charCode;

    if( event.keyCode == 13 ){

      this.addSerie(event.target.value);
    }
  }

  onChange(serie){
    if ( serie.is_selected ) {
      this.series.push(serie);
    } else {
      let i = this.series.findIndex(x => x.codigo.toString().trim() == serie.codigo.toString().trim());
      this.series.splice(i, 1);
      this.selectAll = false;
    }
    this.codigo = "";
  }

  addSerie(codigo){
    this.serie_barcode = null;
    this.not_found_code = null;
    let serie = this.series_all.filter(x => x.codigo.toString().trim() == codigo.toString().trim())[0];
    if(serie){
      let serie_existente = this.series.filter(x => x.codigo.toString().trim() == serie.codigo.toString().trim())[0];
      if(!serie_existente) {
        serie.is_selected = true;
        this.serie_barcode = serie;
        this.series.push(serie);
      }
     
    }else {
      this.not_found_code = this.codigo.toString().trim();
      setTimeout(() => {
        this.not_found_code = null;
      }, 2000);
     
    }
    this.codigo = "";
  }

  onSelectAll() {
    this.series = [];-
    this.series_all.forEach(serie => {
      serie.is_selected = this.selectAll;
      if(this.selectAll && serie.is_selected){
        this.series.push(serie);
      }
    });
  }

  getAllByInventario(){
    return new Promise ((resolve, reject)=>{
      this.serieService.getAllByInventario("?bodega_id="+this.bodega_id+"&producto_id="+this.producto_id).subscribe(
        res => {
          this.series_all = res.data;
          this.setSelected();
        }
        ,err => {
         
            reject(err);
        }
      )
  
  
    });
  }
  onSubmit(){
    this.sendSeries.emit(this.series);
    this.bsModalRef.hide();
  }


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/serie-egreso-modal/serie-egreso-modal.component.ts